/**
 * ACTIVITY-CORE (L1) — compensatory server-side revert from the feed.
 *
 * `POST /api/activity/{id}/revert`: the server applies the patch's `old` values
 * through the normal write path and records a `reverted` entry (server-authoritative,
 * compatible with multi-user/offline use). Immediate L1 undo (pill / Ctrl+Z) is
 * local-first; THIS is the history's durable "undo".
 *
 * NOTE (fallback without types): the endpoint is not yet in the generated types
 * for `@mealplan/client` (requires `make rust-gen-api-types` with the server
 * compiling), so we make an UNTYPED fetch that replicates the cookie-BFF web
 * transport (device cookie `credentials: "include"` + `X-Active-Account`
 * selector). After regenerating the types, migrate to `api.POST(...)`.
 */
import { SERVER_BASE_URL } from "@/lib/api";
import { readActiveAccountSelector } from "@/lib/accounts";

export async function revertActivity(id: string): Promise<void> {
  const headers: Record<string, string> = { "content-type": "application/json" };
  const selector = readActiveAccountSelector();
  if (selector) {
    headers["X-Active-Account"] = selector;
  }
  const response = await fetch(`${SERVER_BASE_URL}/api/activity/${encodeURIComponent(id)}/revert`, {
    method: "POST",
    credentials: "include",
    headers,
  });
  if (!response.ok) {
    throw new Error(`revert failed with status ${response.status}`);
  }
}
